export const LIFT_FAULT_CODE = [
  { value: "0100", label: "Controller" },
  { value: "0101", label: "Relays" },
  { value: "0102", label: "Contactors" },
  { value: "0103", label: "Resistors" },
  { value: "0104", label: "Fuse" },
  { value: "0105", label: "Selectors" },
  { value: "0106", label: "OCR" },
  { value: "0107", label: "Timers" },
  { value: "0108", label: "PCB" },
  { value: "0109", label: "Transformer" },
  { value: "0110", label: "Rectifier" },
  { value: "0111", label: "Condenser" },
  { value: "0112", label: "Wiring" },
  { value: "0113", label: "Vector Drive" },
  { value: "0114", label: "AVR" },
  { value: "0115", label: "MCB" },
  { value: "0200", label: "Traction machine" },
  { value: "0201", label: "Traction motor" },
  { value: "0202", label: "Motor windings" },
  { value: "0203", label: "Brake" },
  { value: "0204", label: "Main sheave" },
  { value: "0205", label: "Secondary sheave" },
  { value: "0206", label: "Bearing" },
  { value: "0207", label: "Bushes" },
  { value: "0208", label: "Oil seals" },
  { value: "0209", label: "Fan blower" },
  { value: "0210", label: "Pulse Encoder" },
  { value: "0300", label: "MG set" },
  { value: "0400", label: "Governor" },
  { value: "0500", label: "Travelling cables" },
  { value: "0600", label: "Wire ropes" },
  { value: "0700", label: "Car cage/door operation" },
  { value: "0701", label: "Car door / OTL switch defective" },
  { value: "0702", label: "Safety edge" },
  { value: "0704", label: "Car push button" },
  { value: "0709", label: "Door motor" },
  { value: "0710", label: "Door pulley" },
  { value: "0712", label: "CAR DOOR SILL" },
  { value: "0713", label: "Car door shoe" },
  { value: "0714", label: "Car door switch" },
  { value: "0715", label: "Door chain / door belt" },
  { value: "0716", label: "Door sensor" },
  { value: "0717", label: "Overload Switch" },
  { value: "0718", label: "Trap Door Switch" },
  { value: "0800", label: "Landing door" },
  { value: "0801", label: "Landing door hanger roller" },
  { value: "0802", label: "Landing door shoes" },
  { value: "0803", label: "Landing door lock" },
  { value: "0804", label: "Landing door sill" },
  { value: "0806", label: "Landing door push button" },
  { value: "0807", label: "Landing door weight" },
  { value: "0900", label: "Safety catch mechanism" },
  { value: "0901", label: "Safety catch jaws" },
  { value: "0902", label: "Safety catch rollers" },
  { value: "0903", label: "SOS switch" },
  { value: "1000", label: "Hoistway" },
  { value: "1001", label: "Inductor" },
  { value: "1002", label: "Limit switches" },
  { value: "1003", label: "Guide rails" },
  { value: "1004", label: "Guide shoes (car/cwt)" },
  { value: "1005", label: "Compensating chain /rope" },
  { value: "1006", label: "Governor Tension Pulley Switch" },
  { value: "1100", label: "Anti-crime siren" },
  { value: "1200", label: "EBOPS Trips/faulty" },
  { value: "1300", label: "ARD fault" },
  { value: "1401", label: "Door sill stuck by objects" },
  { value: "1402", label: "Push button jammed" },
  { value: "1403", label: "Door forced out of track" },
  { value: "1404", label: "Fireman switch" },
  { value: "1405", label: "Activation Of Fire Alarm (Not By Authority)" },
  { value: "1499", label: "Other defects caused by vandalism" },
  { value: "1500", label: "False call" },
  { value: "1501", label: "Fault clear upon arrival" },
  { value: "1600", label: "Under-voltage / no power supply" },
  { value: "1700", label: "Fault cleared before arrival/despatch" },
  { value: "1701", label: "Servicing / Minor Repair" },
  { value: "1702", label: "TMS work in progress" },
  { value: "1703", label: "Lift switched off by TC/BO" },
  { value: "1704", label: "Fan noisy / not working" },
  { value: "1705", label: "Car light not working" },
  { value: "1706", label: "Indicator light not working or blown" },
  { value: "1707", label: "Lift jerky /noisy" },
  { value: "1708", label: "Alarm bell not working" },
  { value: "1709", label: "Door slammed on closing" },
  { value: "1710", label: "Lift smelly /dirty/ UDD activated" },
  { value: "1711", label: "Poor leveling" },
  { value: "1712", label: "Animal/Key /etc in lift pit" },
  { value: "1713", label: "Elcb (Machine Room) Tripped" },
  { value: "1714", label: "MRI - Door Contact faulty" },
  { value: "1715", label: "MRI - Door Contact missing" },
  { value: "1716", label: "MRI - Door missing" },
  { value: "1717", label: "MRI - LM key not inserted" },
  { value: "1718", label: "MRI - LM keyswitch faulty" },
  { value: "1719", label: "MRI - EBOPS voltage problem" },
  { value: "1800", label: "Other types of breakdown" },
  { value: "1801", label: "Overrun" },
  { value: "1900", label: "Close Lift Fault" },
  { value: "2000", label: "Spare" },
  { value: "2100", label: "MIC Tripped" },
  { value: "2101", label: "Door opening error code" },
  { value: "2102", label: "Door closing error code" },
  { value: "2103", label: "Speed control error code" },
  { value: "2104", label: "Deceleration error code" },
  { value: "2105", label: "Leveling error code" },
  { value: "2106", label: "Acceleration error code" },
  { value: "5001", label: "Replacement of car cage" },
  { value: "5002", label: "Major repair of car cage" },
  { value: "5003", label: "Replacement/addition of travelling cables" },
  { value: "5004", label: "Replacement of main wire rope" },
  { value: "5005", label: "Replacement/regrove of main sheave" },
  { value: "5006", label: "Replacement of main rope and sheave" },
  { value: "5007", label: "Replacement of secondary sheave/bearing" },
  { value: "5008", label: "Replacement of governor rope" },
  { value: "5009", label: "Replacement of governor pulley/bearing" },
  { value: "5010", label: "Rewinding of main motor" },
  { value: "5011", label: "Replacement of Worm gear" },
  { value: "5012", label: "Replacement of worm shaft" },
  { value: "5013", label: "Replacement of worm gear & shaft" },
  { value: "5014", label: "Replacement of worm bearing/bush" },
  { value: "5015", label: "Replacement of stand bearing/bush" },
  { value: "5016", label: "Replacement of motor bearing/bush" },
  { value: "5017", label: "Replacement of thrust bearing" },
  { value: "5018", label: "Replacement of oil real" },
  { value: "5019", label: "Replacement of brake wiring" },
  { value: "5020", label: "Replacement of PVC tiling" },
  { value: "5021", label: "Replacement/repair of car door" },
  { value: "5022", label: "Replacement/repair of car door sill" },
  { value: "5023", label: "Replacement/repair of car panel & formica" },
  { value: "5024", label: "Replacement/repair of car platform" },
  { value: "5025", label: "Replacement/repair of landing door" },
  { value: "5026", label: "Replacement/repair of landing door sill" },
  { value: "5027", label: "Replacement/repair of landing door jamb" },
  { value: "5028", label: "Burnt car cage" },
  { value: "5029", label: "Car cage wet" },
  { value: "5030", label: "Safety gear not working" },
  { value: "5031", label: "Car top & lift pit wet" },
  { value: "5032", label: "Alarm/siren not working" },
  { value: "5099", label: "Others major fault/repair" },
  { value: "9900", label: "Fault not known (mainswitch off by LEU/unknown)" },
];
